/* tslint:disable */
/* eslint-disable */
/**
 * CVAT REST API
 * REST API for Computer Vision Annotation Tool (CVAT)
 *
 * The version of the OpenAPI document: 2.31.0
 * Contact: support@cvat.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * * `cloud_storage` - CLOUD_STORAGE * `local` - LOCAL
 * @export
 * @enum {string}
 */

export const LocationEnum = {
    CloudStorage: 'cloud_storage',
    Local: 'local'
} as const;

export type LocationEnum = typeof LocationEnum[keyof typeof LocationEnum];



